import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    group: [],
    groupList: [],
    //用來啟動新增頁面
    flag: 0,

    //切換到未讀列表
    unreadGroupShow: 0,
  },
  getters: {},
  actions: {
    showDialog: function (context, group) {
      context.commit("show_Dialog", group);
    },
    setGroupList: function (context, groupList) {
      context.commit("set_GroupList", groupList);
    },
    unreadGroupShow: function (context) {
      context.commit("unreadList_Show");
    },
  },
  mutations: {
    show_Dialog: function (state, group) {
      state.group = group;
      state.flag = state.flag + 1;
    },
    set_GroupList: function (state, groupList) {
      state.groupList = groupList;
    },
    unreadList_Show: function (state) {
      state.unreadGroupShow = state.unreadGroupShow + 1;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store_groupList.js